import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { TOKEN, USER } from '../constants/storage';
import { isEmpty } from 'src/app/shared/utils/utils';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { ProfileDto } from 'src/app/shared/dto/profile.dto';
import { AuthService } from 'src/app/public/services/auth.service';
import { LocalStorageService } from './storage.service';

@Injectable({
    providedIn: 'root',
})
export class UserLoggedService {

    public userSubject: Subject<UserDto> = new Subject();

    private _user!: UserDto;
    private readonly localStorageService = inject(LocalStorageService);
    private readonly authService = inject(AuthService);

    public get userLogged(): UserDto {
        if (this._user) {
            return this._user;
        }

        const user = this.localStorageService.getItem(USER);

        if (user) {
            this._user = user;

            return this._user;
        }

        this.authService.logout();

        return new UserDto();
    }

    public set userLogged(user: UserDto) {
        this._user = user;
        this.userSubject.next(user);
    }

    public setUserLogged(user: UserDto): void {
        this.userLogged = user;

        if (user !== null) {
            this.localStorageService.setItem(USER, user);
        }
    }

    public setToken(accessToken: string): void {
        if (accessToken !== '') {
            this.localStorageService.setItem(TOKEN, accessToken);
        }
    }

}
